<ng-template [componentId]="{ componentId: 'portfolio.alerts', ids: ids$ }" let-data [loading]="loading">
	<section class="dialog-content padding-40">
		<section class="text-align-center">
			<ng-container *ngIf="singleErrorView">
				<img ada-decorative [remote-src]="imagePath" onerror="this.style.display = 'none'" />
			</ng-container>
			<p class="text-20-bold padding-top-10" [innerHTML]="dialogTitle"></p>
		</section>
		<ng-container *ngIf="hasUnsupportedSleeves">
			<pi-unsupported-sleeves [data]="data" [singleErrorView]="singleErrorView"></pi-unsupported-sleeves>
		</ng-container>

		<ng-container *ngIf="hasUnsupportedSecurities">
			<pi-unsupported-securities [data]="data" [singleErrorView]="singleErrorView"></pi-unsupported-securities>
		</ng-container>

		<pi-unsupported-asset-classes *ngIf="hasSubstitutedAssetClass"></pi-unsupported-asset-classes>

		<section class="footer margin-top-20">
			<p class="text-14" dcrHTMLKey="ANALYZE_TEXT">To analyze your portfolio, you will need to adjust it in our Portfolio Editor.</p>
			<div class="text-align-right padding-top-50">
				<button
					dz-button
					class="text-14 display-inline margin-right-20"
					track-event="partner-porfolio-error-modal:cta:continue"
					dcrHTMLKey="CONTINUE_LABEL"
					(click)="onContinue()"
				>
					Continue
				</button>
			</div>
		</section>
	</section>
</ng-template>

<ng-template #loading>
	<pi-unsupported-import-dialog-skeleton></pi-unsupported-import-dialog-skeleton>
</ng-template>
